export default "__VITE_ASSET__B_om$TpD__"